var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import Input from 'antd/lib/input';
import { polyfill } from 'react-lifecycles-compat';
import { toArrayChildren } from '../../utils';
var Group = Input.Group;
var InputGroup = /** @class */ (function (_super) {
    __extends(InputGroup, _super);
    function InputGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (key, e, isDrag) {
            var values = _this.state.values;
            var value = e && e.target ? e.target.value : e;
            if (key === 'center') {
                _this.props.onChange(value);
                Object.keys(values).forEach(function (cKey) {
                    values[cKey] = value;
                });
            }
            else {
                values[key] = value;
                values.center = null;
                _this.props.onChange(values, isDrag);
            }
            _this.setState({
                values: values,
            });
        };
        _this.getValues = function (props) {
            var values = {};
            toArrayChildren(props.children).forEach(function (item) {
                var key = item.key;
                values[key] = item.props.defaultValue || item.props.value || item.props.color;
            });
            return values;
        };
        var values = _this.getValues(props);
        _this.state = {
            values: values,
            getValues: _this.getValues,
        };
        return _this;
    }
    InputGroup.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps, getValues = _a.getValues;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.children !== props.children) {
            var values = getValues(props);
            nextState.values = values;
        }
        return nextState;
    };
    InputGroup.prototype.render = function () {
        var _this = this;
        var props = __rest(this.props, []);
        ['onChange'].forEach(function (key) { return delete props[key]; });
        var children = toArrayChildren(props.children).map(function (item) {
            if (!item) {
                return null;
            }
            var onChange = function (e, isDrag) {
                _this.onChange(item.key, e, isDrag);
            };
            return React.cloneElement(item, __assign(__assign({}, item.props), { onChange: onChange }));
        });
        return React.createElement(Group, props, children);
    };
    InputGroup.propTypes = {
        children: PropTypes.any,
        onChange: PropTypes.func,
    };
    InputGroup.defaultProps = {
        onChange: function () {
        },
    };
    return InputGroup;
}(React.Component));
export default polyfill(InputGroup);
